"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");var _interopRequireWildcard = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireWildcard");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");require("core-js/modules/es6.array.sort");require("core-js/modules/es6.array.find");require("core-js/modules/es6.function.name");require("core-js/modules/web.dom.iterable");



























































































































































































































































































var _formatter = require("@/utils/formatter");
var _lodash = _interopRequireWildcard(require("lodash"));
var _sortablejs = _interopRequireDefault(require("sortablejs")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { deviceCode: '', //当前设备型号
      configId: 0, //配置id
      tableColumn: [{ prop: 'programName', label: '程序指令名称' }, { prop: 'reasonStr', label: '推荐原因', formatter: _formatter.recommendNewReasonFormatter }, { prop: 'description', label: '原因介绍' }, { prop: 'conditionsStr', label: '推荐条件' }], //表格表头
      supplyTableColumn: [{ prop: 'programName', label: '程序指令名称' }, { prop: 'description', label: '原因介绍' }], //表格表头
      newList: [], //新用户配置列表
      newReasonList: [], //新用户原因列表
      oldList: [], //旧用户配置列表
      supplyList: [], //补充列表
      showNew: false, //是否显示新用户配置弹窗
      showOld: false, //是否显示旧用户配置弹窗
      showSupply: false, //是否显示补充配置弹窗
      newForm: { reason: '', programId: '', description: '', conditions: [] }, //新用户配置表单
      newFormRule: { reason: [{ required: true, message: '请选择推荐规则', trigger: 'change' }], programId: [{ required: true, message: '请选择程序', trigger: 'change' }], conditions: [{ required: true, message: '请添加推荐条件', trigger: 'change' }] }, //新用户配置表单rule
      conditionTableColumn: [{ prop: 'name', label: '程序名称' }, { prop: 'gender', label: '性别' }, { prop: 'type', label: '类型' }, { prop: 'condition', label: '推荐条件' }], //推荐条件表格表头
      showCondition: false, //是否显示添加推荐条件弹窗
      conditionForm: { programId: '', gender: [], type: [], typeRadio: '', typeValue: '', bmi: '' }, //添加推荐条件表单
      conditionFormRule: { programId: [{ required: true, message: '请选择程序', trigger: 'change' }], gender: [{ required: true, message: '请选择性别', trigger: 'change' }], type: [{ required: true, message: '请选择推荐类别', trigger: 'change' }], typeValue: [{ required: true, message: '请输入', trigger: ['change', 'blur'] }], bmi: [{ required: true, message: '请输入BMI', trigger: ['change', 'blur'] }] }, //添加推荐条件表单rule
      bmiMin: '', //BMI最小值
      bmiMax: '', //BMI最大值
      isSetType: false, //是否手动设置type
      oldReasonList: [], //旧用户推荐原因列表
      conditionType: '', //推荐条件类型 'new', 'old'
      oldForm: { reason: '', programId: '', description: '', conditions: [] }, //旧用户配置表单
      oldFormRule: { reason: [{ required: true, message: '请选择推荐原因', trigger: 'change' }], programId: [{ required: true, message: '请选择程序', trigger: 'change' }], conditions: [{ required: true, message: '请添加推荐条件', trigger: 'change' }] }, //旧用户配置表单rule
      supplyForm: { programId: '', description: '' }, //补充程序表单
      supplyFormRule: { programId: [{ required: true, message: '请选择程序', trigger: 'change' }] }, //补充程序表单rule
      programList: [], //自动程序列表
      conditionsList: [], //推荐类别列表
      configEdit: false, //是否正在编辑
      delIds: [], //删除配置条件的id
      pushCount: '', //推送程序套数
      hasMin: false, //是否填写BMI最小值
      hasMax: false //是否填写BMI最大值
    };}, computed: { conditionGender: function conditionGender() {return function (gender) {var list = [];gender.value.forEach(function (e) {if (e == 0) {list.push('女');} else if (e == 1) {list.push('男');}});return list.join(',');};}, conditionTypeName: function conditionTypeName() {var _this2 = this;return function (conditions) {var list = [];conditions.forEach(function (e) {list.push(_lodash.default.find(_this2.conditionsList, function (o) {return o.code == e.code;}).name);});return list.join(',');};}, conditionTermName: function conditionTermName() {var _this3 = this;return function (conditions) {var list = [];conditions.forEach(function (e) {var term = _lodash.default.find(_this3.conditionsList, function (o) {return o.code == e.code;});if (e.code != 'bmi') {var limitName = _this3.termLimitName(e.rule);list.push(term.name + limitName + e.value + term.unit);} else {if (e.type == 2 && e.rule == 2) {//大于某个值
              list.push('BMI高于' + e.value + term.unit);}if (e.type == 2 && e.rule == 4) {//小于某个值
              list.push('BMI低于' + e.value + term.unit);}if (e.type == 3) {list.push('BMI介于' + e.value[0] + term.unit + '到' + e.value[1] + term.unit + '之间');}}});return list.join(',');};}, termLimitName: function termLimitName() {return function (type) {switch (type + '') {case '1':return '大于等于';break;case '2':return '大于';break;case '3':return '小于等于';break;case '4':return '小于';break;}};}, programName: function programName() {var _this4 = this;return function (row) {if (row.programId) {return _lodash.default.find(_this4.programList, function (e) {return e.id == row.programId;}).name;} else {var list = [];row.conditions.forEach(function (e) {list.push(_lodash.default.find(_this4.programList, function (o) {return o.id == e.programId;}).name);});return list.join(',');}};}, disableNew: function disableNew() {var res = false;if (parseInt(this.newForm.reason) == 1) {//猜你喜欢
        if (!this.newForm.conditions.length) {res = true;}} else if (parseInt(this.newForm.reason) == 2) {//普通套餐
        if (!this.newForm.programId) {res = true;}} else {res = true;}return res;}, disableOld: function disableOld() {var res = false;if (!this.oldForm.reason) {res = true;}if ((this.oldForm.reason == 1 || this.oldForm.reason == 2) && !this.oldForm.programId) {res = true;}if (this.oldForm.reason == 3 && !this.oldForm.conditions.length) {res = true;}return res;}, disableCondition: function disableCondition() {// console.log('conditionForm=====>',JSON.stringify(this.conditionForm))
      if (!this.conditionForm.programId) {return true;}if (!this.conditionForm.gender.length) {return true;}if (!this.hasWeight && !this.hasAge && !this.hasHeight && !this.hasBMI) {return true;}if ((this.hasWeight || this.hasAge || this.hasHeight) && (!this.conditionForm.type.length || !this.conditionForm.typeValue)) {return true;}if (this.hasBMI && !this.conditionForm.bmi) {return true;}return false;}, disableSupply: function disableSupply() {if (!this.supplyForm.programId) {return true;} else {return false;}}, hasAge: function hasAge() {return this.conditionForm.type.indexOf('age') >= 0;}, hasHeight: function hasHeight() {return this.conditionForm.type.indexOf('height') >= 0;}, hasWeight: function hasWeight() {return this.conditionForm.type.indexOf('weight') >= 0;
    },

    hasBMI: function hasBMI() {
      return this.conditionForm.type.indexOf('bmi') >= 0;
    } },


  watch: {
    "conditionForm.type": {
      handler: function handler(newVal, oldVal) {
        if (this.isSetType) {
          this.isSetType = false;
          return;
        }
        if (newVal.indexOf('bmi') >= 0) {
          //包含BMI
          var oldIndex = oldVal.indexOf('bmi');
          if (oldIndex >= 0) {
            oldVal.splice(oldIndex, 1);
          }
          if (newVal.length != 2) {
            newVal = _lodash.default.difference(newVal, oldVal);
            this.isSetType = true;
            this.$set(this.conditionForm, 'type', newVal);
          }
        } else {
          //不包含BMI
          var _oldIndex = oldVal.indexOf('bmi');
          if (_oldIndex >= 0) {
            oldVal.splice(_oldIndex, 1);
          }
          if (newVal.length != 1) {
            newVal = _lodash.default.difference(newVal, oldVal);
            this.isSetType = true;
            this.$set(this.conditionForm, 'type', newVal);
          }
        }
        // this.$set(this.conditionForm, 'typeRadio', '')
        // this.$set(this.conditionForm, 'typeValue', '')
      },
      deep: true },

    bmiMin: {
      handler: function handler(val) {
        if (val) {
          this.hasMin = true;
          if (this.bmiMax) {
            this.$set(this.conditionForm, 'bmi', val + '~' + this.bmiMax);
          } else {
            this.$set(this.conditionForm, 'bmi', val);
          }
        } else {
          this.hasMin = false;
          if (this.bmiMax) {
            this.$set(this.conditionForm, 'bmi', this.bmiMax);
          } else {
            this.$set(this.conditionForm, 'bmi', '');
          }
        }
      },
      deep: true },


    bmiMax: {
      handler: function handler(val) {
        if (val) {
          this.hasMax = true;
          if (this.bmiMin) {
            this.$set(this.conditionForm, 'bmi', this.bmiMin + '~' + val);
          } else {
            this.$set(this.conditionForm, 'bmi', val);
          }
        } else {
          this.hasMax = false;
          if (this.bmiMin) {
            this.$set(this.conditionForm, 'bmi', this.bmiMin);
          } else {
            this.$set(this.conditionForm, 'bmi', '');
          }
        }
      },
      deep: true } },



  mounted: function mounted() {
    this.configId = this.$route.params.parentId;
    this.deviceCode = this.$route.params.deviceCode;
    this.fetchConfig();
    this.fetchProgramList();
    this.fetchConditionList();
    this.fetchReasonList();
    this.fetchPushCount();
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    this.newRowDrop();
    this.oldRowDrop();
    this.supplyRowDrop();
  },

  methods: {
    /**
              * 新用户原因formatter
              */
    newReasonFormatter: function newReasonFormatter(row, column) {
      var val = row[column.property];
      return _lodash.default.find(this.newReasonList, function (e) {return e.id == val;}).name;
    },

    /**
        * 新用户拖拽排序
        */
    newRowDrop: function newRowDrop() {
      var tbody = document.querySelector('#newListTable .el-table__body-wrapper tbody');
      var _this = this;
      _sortablejs.default.create(tbody, {
        handle: '.handle',
        onEnd: function onEnd(_ref) {var newIndex = _ref.newIndex,oldIndex = _ref.oldIndex;
          if (newIndex == oldIndex) return;
          _this.updateSort(_this.newList[oldIndex].id, 2, _this.newList[oldIndex].sort, _this.newList[newIndex].sort);
        } });

    },
    /**
        * 旧用户拖拽排序
        */
    oldRowDrop: function oldRowDrop() {
      var tbody = document.querySelector('#oldListTable .el-table__body-wrapper tbody');
      var _this = this;
      _sortablejs.default.create(tbody, {
        handle: '.handle',
        onEnd: function onEnd(_ref2) {var newIndex = _ref2.newIndex,oldIndex = _ref2.oldIndex;
          if (newIndex == oldIndex) return;
          _this.updateSort(_this.oldList[oldIndex].id, 5, _this.oldList[oldIndex].sort, _this.oldList[newIndex].sort);
        } });

    },
    /**
        * 补充程序拖拽排序
        */
    supplyRowDrop: function supplyRowDrop() {
      var tbody = document.querySelector('#supplyListTable .el-table__body-wrapper tbody');
      var _this = this;
      _sortablejs.default.create(tbody, {
        handle: '.handle',
        onEnd: function onEnd(_ref3) {var newIndex = _ref3.newIndex,oldIndex = _ref3.oldIndex;
          if (newIndex == oldIndex) return;
          _this.updateSort(_this.supplyList[oldIndex].id, 4, _this.supplyList[oldIndex].sort, _this.supplyList[newIndex].sort);
        } });

    },

    /**
        * 更新排序
        */
    updateSort: function updateSort(id, type, currentSort, targetSort) {var _this5 = this;
      var params = {
        id: id,
        type: type,
        currentSort: currentSort,
        targetSort: targetSort };

      this.postData('/api/todayRecommend/device/' + this.configId + '/config/sort', params, function (res) {
        _this5.fetchConfig();
      });
    },

    /**
        * 获取当前配置的所有条件
        */
    fetchConfig: function fetchConfig() {var _this6 = this;
      this.newList = [];
      this.oldList = [];
      this.supplyList = [];
      this.getData('/api/todayRecommend/device/' + this.configId + '/config', {}, function (res) {
        _this6.newList = _lodash.default.find(res.configs, function (e) {return e.type == 2;}) ? _lodash.default.find(res.configs, function (e) {return e.type == 2;}).recommendPrograms : [];
        _this6.oldList = _lodash.default.find(res.configs, function (e) {return e.type == 5;}) ? _lodash.default.find(res.configs, function (e) {return e.type == 5;}).recommendPrograms : [];
        _this6.supplyList = _lodash.default.find(res.configs, function (e) {return e.type == 4;}) ? _lodash.default.find(res.configs, function (e) {return e.type == 4;}).recommendPrograms : [];
        // console.log('newList=====>',this.newList)
        // this.onClickAddNew()
      });
    },

    /**
        * 根据型号获取自动程序列表
        */
    fetchProgramList: function fetchProgramList() {var _this7 = this;
      this.getData('/api/faProgram/', { typeCode: this.deviceCode, page: 1, rows: 10000 }, function (res) {
        _this7.programList = res.list;
      });
    },

    /**
        * 获取配置条件列表
        */
    fetchConditionList: function fetchConditionList() {var _this8 = this;
      this.getData('/api/todayRecommend/conditions', {}, function (res) {
        _this8.conditionsList = res.conditions;
      });
    },

    /**
        * 获取原因列表
        */
    fetchReasonList: function fetchReasonList() {var _this9 = this;
      this.getData('/api/todayRecommend/reasons/2', {}, function (res) {
        _this9.newReasonList = res.reasons;
      });
      this.getData('/api/todayRecommend/reasons/5', {}, function (res) {
        _this9.oldReasonList = res.reasons;
      });
    },

    /**
        * 获取推送程序套数
        */
    fetchPushCount: function fetchPushCount() {var _this10 = this;
      this.getData('/api/todayRecommend/device/' + this.configId + '/pushCount', {}, function (res) {
        _this10.pushCount = res;
      });
    },

    /**
        * 弹窗关闭回调
        */
    onDialogClose: function onDialogClose(type) {var _this11 = this;
      switch (type) {
        case 'new':
          this.configEdit = false;
          this.delIds = [];
          this.$nextTick(function () {
            _this11.$set(_this11.newForm, 'id', '');
            _this11.$set(_this11.newForm, 'reason', '');
            _this11.$set(_this11.newForm, 'description', '');
            _this11.$set(_this11.newForm, 'programId', '');
            _this11.$set(_this11.newForm, 'conditions', []);
          });
          break;
        case 'old':
          this.configEdit = false;
          this.delIds = [];
          this.$nextTick(function () {
            _this11.$set(_this11.oldForm, 'id', '');
            _this11.$set(_this11.oldForm, 'reason', '');
            _this11.$set(_this11.oldForm, 'description', '');
            _this11.$set(_this11.oldForm, 'programId', '');
            _this11.$set(_this11.oldForm, 'conditions', []);
            _this11.$refs.oldForm.resetFields();
            _this11.$refs.oldForm.clearValidate();
          });
          break;
        case 'condition':
          this.$nextTick(function () {
            _this11.$refs.conditionForm.resetFields();
            _this11.bmiMin = '';
            _this11.bmiMax = '';
          });
          break;
        case 'supply':
          this.configEdit = false;
          this.$nextTick(function () {
            _this11.$refs.supplyForm.resetFields();
          });
          break;
        default:
          break;}

    },

    /**
        * 新增新用户配置
        */
    onClickAddNew: function onClickAddNew() {
      if (this.$refs.newForm) {
        this.$refs.newForm.resetFields();
      }
      this.showNew = true;
    },

    /**
        * 编辑新用户程序配置
        */
    updateNewItem: function updateNewItem(row) {var _this12 = this;
      this.getData('/api/todayRecommend/device/' + this.configId + '/config/' + row.id, {}, function (res) {
        _this12.showNew = true;
        _this12.configEdit = true;
        _this12.$nextTick(function () {
          _this12.$set(_this12.newForm, 'id', res.id);
          _this12.$set(_this12.newForm, 'reason', res.reason);
          _this12.$set(_this12.newForm, 'description', res.description);
          _this12.$set(_this12.newForm, 'programId', res.programId);
          _this12.$set(_this12.newForm, 'conditions', res.conditions);
        });
      });
    },

    /**
        * 删除新用户程序配置
        */
    delNewItem: function delNewItem(row) {var _this13 = this;
      this.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        _this13.delData('/api/todayRecommend/device/' + _this13.configId + '/config/' + row.id, {}, function (res) {
          _this13.fetchConfig();
        });
      }).catch({});
    },

    /**
        * 删除新用户条件配置
        */
    delNewConditionItem: function delNewConditionItem(row) {var _this14 = this;
      this.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        _this14.delIds.push(row.id);
        _this14.newForm.conditions.splice(_this14.newForm.conditions.indexOf(row), 1);
      }).catch({});
    },

    /**
        * 新用户保存
        */
    onSaveNewConfig: function onSaveNewConfig() {var _this15 = this;
      var params = Object.assign({}, this.newForm);
      params.type = 2;
      if (!this.configEdit) {
        params.id = 0;
      } else {
        params.deleteConfigIds = this.delIds;
      }
      if (params.reason == 1) {
        params.gussLikeConfig = params.conditions;
      }
      delete params['conditions'];
      console.log('params=====>', JSON.stringify(params));
      // return
      this.postData('/api/todayRecommend/device/' + this.configId + '/config', params, function (res) {
        _this15.delIds = [];
        _this15.showNew = false;
        _this15.$nextTick(function () {
          _this15.$refs.newForm.resetFields();
        });
        _this15.fetchConfig();
      });
    },

    /**
        * 添加旧用户配置
        */
    onClickAddOld: function onClickAddOld() {
      if (this.$refs.oldForm) {
        this.$refs.oldForm.resetFields();
      }
      this.showOld = true;
    },

    /**
        * 推送套数-blur
        */
    onPushCountBlur: function onPushCountBlur() {var _this16 = this;
      this.postData('/api/todayRecommend/device/pushCount', { id: this.configId, pushCount: this.pushCount }, function (res) {
        _this16.fetchPushCount();
      });
    },

    /**
        * 编辑旧用户程序配置
        */
    updateOldItem: function updateOldItem(row) {var _this17 = this;
      this.getData('/api/todayRecommend/device/' + this.configId + '/config/' + row.id, {}, function (res) {
        _this17.showOld = true;
        _this17.configEdit = true;
        _this17.$nextTick(function () {
          _this17.$set(_this17.oldForm, 'id', res.id);
          _this17.$set(_this17.oldForm, 'reason', res.reason);
          _this17.$set(_this17.oldForm, 'description', res.description);
          _this17.$set(_this17.oldForm, 'programId', res.programId);
          _this17.$set(_this17.oldForm, 'conditions', res.conditions);
        });
      });
    },

    /**
        * 删除旧用户程序配置
        */
    delOldItem: function delOldItem(row) {var _this18 = this;
      this.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        _this18.delData('/api/todayRecommend/device/' + _this18.configId + '/config/' + row.id, {}, function (res) {
          _this18.fetchConfig();
        });
      }).catch({});
    },

    /**
        * 删除旧用户条件配置
        */
    delOldConditionItem: function delOldConditionItem(row) {var _this19 = this;
      this.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        _this19.delIds.push(row.id);
        _this19.oldForm.conditions.splice(_this19.oldForm.conditions.indexOf(row), 1);
      }).catch({});
    },

    /**
        * 旧用户保存
        */
    onSaveOldConfig: function onSaveOldConfig() {var _this20 = this;
      var params = Object.assign({}, this.oldForm);
      // console.log('params1====>',JSON.stringify(params))
      // console.log('configEdit=====>', this.configEdit)
      params.type = 5;
      if (!this.configEdit) {
        params.id = 0;
      } else {
        params.deleteConfigIds = this.delIds;
      }
      if (params.reason == 3) {
        params.gussLikeConfig = params.conditions;
      }
      delete params['conditions'];
      // console.log('params====>',JSON.stringify(params))
      // return
      this.postData('/api/todayRecommend/device/' + this.configId + '/config', params, function (res) {
        _this20.delIds = [];
        _this20.showOld = false;
        _this20.fetchConfig();
      });
    },

    /**
        * 编辑补充程序配置
        */
    updateSupplyItem: function updateSupplyItem(row) {var _this21 = this;
      this.getData('/api/todayRecommend/device/' + this.configId + '/config/' + row.id, {}, function (res) {
        _this21.showSupply = true;
        _this21.configEdit = true;
        _this21.$nextTick(function () {
          _this21.$set(_this21.supplyForm, 'id', res.id);
          _this21.$set(_this21.supplyForm, 'programId', res.programId);
          _this21.$set(_this21.supplyForm, 'description', res.description);
        });
      });
    },

    /**
        * 删除补充程序配置
        */
    delSupplyItem: function delSupplyItem(row) {var _this22 = this;
      this.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        _this22.delData('/api/todayRecommend/device/' + _this22.configId + '/config/' + row.id, {}, function (res) {
          _this22.fetchConfig();
        });
      }).catch({});
    },

    /**
        * 补充程序保存
        */
    onSaveSupplyConfig: function onSaveSupplyConfig() {var _this23 = this;
      var params = Object.assign({}, this.supplyForm);
      if (!this.configEdit) {
        params.id = 0;
      }
      params.type = 4;
      // console.log('params====>',JSON.stringify(params))
      this.postData('/api/todayRecommend/device/' + this.configId + '/config', params, function (res) {
        _this23.showSupply = false;
        _this23.fetchConfig();
      });
    },

    /**
        * BMI输入-change
        */
    onBMIChange: function onBMIChange(event, type) {

    },

    /**
        * 推荐条件保存
        */
    onSaveCondition: function onSaveCondition() {var _this24 = this;
      this.$refs.conditionForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this24.conditionForm);
          params.sex = {
            code: 'sex',
            type: 1,
            value: params.gender,
            rule: '' };

          delete params['gender'];
          params.conditions = [];
          params.type.forEach(function (e) {
            var tmp = {
              code: e };

            if (e == 'bmi') {
              // console.log('hasMax======>',this.hasMax)
              // console.log('hasMin======>',this.hasMin)
              if (_this24.hasMax && !_this24.hasMin) {
                //只填写最大值
                tmp.type = 2;
                tmp.rule = 4;
                tmp.value = params.bmi;
              }
              if (_this24.hasMin && !_this24.hasMax) {
                //只填写最小值
                tmp.type = 2;
                tmp.rule = 2;
                tmp.value = params.bmi;
              }
              if (_this24.hasMax && _this24.hasMin) {
                //填写最大及最小值
                tmp.type = 3;
                tmp.value = params.bmi.split('~');
              }
            } else {
              tmp.rule = params.typeRadio;
              tmp.value = params.typeValue;
              tmp.type = 2;
            }
            params.conditions.push(tmp);
          });
          delete params['typeRadio'];
          delete params['typeValue'];
          delete params['type'];
          delete params['bmi'];
          params.id = 0;
          // console.log('params====>',JSON.stringify(params))
          _this24.showCondition = false;
          _this24.hasMin = false;
          _this24.hasMax = false;
          _this24.$nextTick(function () {
            _this24.$refs.conditionForm.resetFields();
          });
          if (_this24.conditionType == 'new') {
            //新用户
            _this24.newForm.conditions.push(params);
          } else {
            //旧用户
            _this24.oldForm.conditions.push(params);
          }
        }
      });
    } } };exports.default = _default;